module.exports = "./img/specials-btn.dc001ab.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/specials-btn.png
// module id = 656
// module chunks = 0